import React from 'react';

const SortCode = (props) => {
    const {
        name = '',
        value = '',
        type = 'text',
        onChange = (value) => {},
        disabled = false
    } = props;

    const handleInputChange = (event) => {
        const sortCode = event.target.value
            .replace(/\D/g, '')
            .slice(0, 6);

        const formattedSortCode = sortCode.replace(/(\d{2})(?=\d)/g, '$1-');

        onChange(formattedSortCode);
    };

    return (
        <input type={type}
               value={value}
               onChange={handleInputChange}
               disabled={disabled}
               name={name}
               id={name}
               className={'input-field'}
               autoComplete="off"
        />
    );
};

export default SortCode;
